import React from 'react';
import HeroProfile from '../img/heroiprofile.png';
import gautam from '../img/gautam.jpg';
import ritesh from '../img/Ritesh.jpg';
import { BsLinkedin } from 'react-icons/bs';

const About = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-4 text-center">
          <img
            src={HeroProfile}
            className="rounded-circle mb-3"
            style={{ width: '250px' }}
            alt="Avatar"
          />
          <h5 className="mb-2">
            <strong>Ankush Kumar</strong>
          </h5>
          <p className="text-muted">
            Web Developer <span className="badge bg-primary">PRO</span>
            <span className="linkedinIcon">
              <a
                href="https://www.linkedin.com/in/ankush2093/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsLinkedin size="25px" />
              </a>
            </span>
          </p>
        </div>

        <div className="col-md-4 text-center">
          <img
            src={gautam}
            className="rounded-circle mb-3"
            style={{ width: '250px', height: '270px' }}
            alt="Avatar"
          />
          <h5 className="mb-2">
            <strong>Gautam Kumar Sharma</strong>
          </h5>
          <p className="text-muted">
            Mern Stack Developer <span className="badge bg-primary">PRO</span>
            <span className="linkedinIcon">
              <a
                href="https://www.linkedin.com/in/gautam-kumar-sharma-29a9b5214/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsLinkedin size="25px" />
              </a>
            </span>
          </p>
        </div>

        <div className="col-md-4 text-center">
          <img
            src={ritesh}
            className="rounded-circle mb-3"
            style={{ width: '250px', height: '270px' }}
            alt="Avatar"
          />
          <h5 className="mb-2">
            <strong>Ritesh Kumar Gosai</strong>
          </h5>
          <p className="text-muted">
            Web Developer <span className="badge bg-primary">PRO</span>
            <span className="linkedinIcon">
              <a
                href="https://www.linkedin.com/in/ritesh-kumar-goswami-b56a5b208?"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsLinkedin size="25px" />
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
